module.exports = __webpack_public_path__ + "frame_back.png";